import type { LiveSearchResult } from '@/scopes/search/search/domain/live-search/types'

import { useIntl } from '@/intl'
import { space } from '@sunwebgroup/ui-components'

import { Icon, IconGlyph, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

import { ShowMore } from '../../../../../../common/components/ShowMore'
import { Item } from './Item'

const Wrapper = styled.div`
  &::before {
    content: '';
    display: block;
    height: 2px;
    margin: 0 ${space('primitives_space_16')} ${space('primitives_space_12')} ${space('primitives_space_16')};
  }
  &:first-child {
    &::before {
      display: none;
    }
  }
`

const Title = styled.div`
  display: flex;
  align-items: center;

  padding: 0 ${space('primitives_space_16')};
  ${Icon} {
    margin-right: ${space('primitives_space_8')};
  }
`

export function Category({ title, icon, items }: { title: string, icon: IconGlyph, items: LiveSearchResult[] }) {
  const intl = useIntl()
  return (
    <Wrapper>
      <Title>
        <Icon glyph={icon} />
        <Typography $variant="body-l-bold-loose">{title}</Typography>
      </Title>
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {items?.map((item, i) => (
          <Item key={i} name={item.name} url={item.url} breadcrumbs={item.breadcrumbs} />
        ))}
      </ShowMore>
    </Wrapper>
  )
}
